import type { SVGProps } from 'react';

const MessageSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M23 10C24.1046 10 25 10.8954 25 12V21C25 22.1046 24.1046 23 23 23H9C7.89543 23 7 22.1046 7 21V12C7 10.8954 7.89543 10 9 10H23ZM16.5996 17.7998L16 18.25L15.4004 17.7998L9 12.999V21H23V12.999L16.5996 17.7998ZM16 15.75L21 12H11L16 15.75Z"
      fill="currentColor"
    />
  </svg>
);
export default MessageSvgIcon;
